var _desc;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 2048 550",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Blender logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A free and open source 3D computer graphics software")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.7861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vlpa",
    transform: "matrix(1 0 0 .8352 7.7861 -42.991)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 51.474,
    width: 2048,
    height: 658.52,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.1667 0 0 4.9888 -191.11 2195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.1923 0 0 5.1923 -1154.3 1375.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.13-333.72c0.106-1.891 1.032-3.557 2.429-4.738 1.37-1.16 3.214-1.869 5.226-1.869 2.01 0 3.854 0.709 5.225 1.869 1.396 1.181 2.322 2.847 2.429 4.736 0.106 1.943-0.675 3.748-2.045 5.086-1.397 1.361-3.384 2.215-5.609 2.215s-4.216-0.854-5.612-2.215c-1.371-1.338-2.15-3.143-2.043-5.084z",
    style: {
      fillRule: "nonzero",
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6642 0 0 2.6642 -520.32 532.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.13-333.72c0.106-1.891 1.032-3.557 2.429-4.738 1.37-1.16 3.214-1.869 5.226-1.869 2.01 0 3.854 0.709 5.225 1.869 1.396 1.181 2.322 2.847 2.429 4.736 0.106 1.943-0.675 3.748-2.045 5.086-1.397 1.361-3.384 2.215-5.609 2.215s-4.216-0.854-5.612-2.215c-1.371-1.338-2.15-3.143-2.043-5.084z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.94-329.89c0.013 0.74 0.249 2.178 0.603 3.301 0.744 2.377 2.006 4.576 3.762 6.514 1.802 1.992 4.021 3.592 6.584 4.728 2.694 1.193 5.613 1.801 8.645 1.796 3.027-4e-3 5.946-0.624 8.64-1.826 2.563-1.147 4.78-2.754 6.579-4.747 1.755-1.946 3.015-4.149 3.761-6.526 0.375-1.201 0.612-2.42 0.707-3.643 0.093-1.205 0.054-2.412-0.117-3.618-0.334-2.35-1.147-4.555-2.399-6.565-1.145-1.847-2.621-3.464-4.376-4.825l4e-3 -3e-3 -17.711-13.599c-0.016-0.012-0.029-0.025-0.046-0.036-1.162-0.892-3.116-0.889-4.394 5e-3 -1.292 0.904-1.44 2.399-0.29 3.342l-5e-3 5e-3 7.387 6.007-22.515 0.024h-0.03c-1.861 2e-3 -3.65 1.223-4.004 2.766-0.364 1.572 0.9 2.876 2.835 2.883l-3e-3 7e-3 11.412-0.022-20.364 15.631c-0.026 0.019-0.054 0.039-0.078 0.058-1.921 1.471-2.542 3.917-1.332 5.465 1.228 1.574 3.839 1.577 5.78 9e-3l11.114-9.096s-0.162 1.228-0.149 1.965zm28.559 4.112c-2.29 2.333-5.496 3.656-8.965 3.663-3.474 6e-3 -6.68-1.305-8.97-3.634-1.119-1.135-1.941-2.441-2.448-3.832-0.497-1.367-0.69-2.818-0.562-4.282 0.121-1.431 0.547-2.796 1.227-4.031 0.668-1.214 1.588-2.311 2.724-3.239 2.226-1.814 5.06-2.796 8.024-2.8 2.967-4e-3 5.799 0.969 8.027 2.777 1.134 0.924 2.053 2.017 2.721 3.229 0.683 1.234 1.106 2.594 1.232 4.029 0.126 1.462-0.067 2.911-0.564 4.279-0.508 1.395-1.327 2.701-2.446 3.841z",
    style: {
      fillRule: "nonzero",
      fill: "#ea7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.47-333.75c0.171-1.908 1.646-3.118 3.899-3.118 2.256 0 3.73 1.21 3.901 3.118h-7.8zm7.569 4.711c-0.577 1.414-1.937 2.251-3.784 2.251-2.313 0-3.87-1.444-3.933-3.725h13.297v-0.671c0-5.714-3.354-8.925-9.364-8.925-5.836 0-9.365 3.241-9.365 8.324 0 5.114 3.584 8.35 9.365 8.35 3.469 0 6.159-1.189 7.817-3.279l-4.033-2.325z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.47-333.74c0.176-1.908 1.651-3.118 3.906-3.118 2.252 0 3.726 1.21 3.899 3.118h-7.805zm7.574 4.711c-0.578 1.418-1.937 2.255-3.788 2.255-2.309 0-3.87-1.448-3.931-3.73h13.294v-0.667c0-5.717-3.353-8.929-9.363-8.929-5.839 0-9.361 3.242-9.361 8.325 0 5.114 3.582 8.35 9.361 8.35 3.468 0 6.16-1.185 7.821-3.278l-4.033-2.326z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.91,
    y: -343.56,
    width: 4.795,
    height: 19.617,
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.81-338.35h4.822v1.168c1.707-1.822 3.757-2.743 6.069-2.743 2.663 0 4.679 0.921 5.72 2.489 0.869 1.295 0.926 2.858 0.926 4.912v8.579h-4.829v-7.538c0-3.128-0.629-4.572-3.375-4.572-2.775 0-4.511 1.653-4.511 4.428v7.682h-4.822v-14.405z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.88-331.54c0 2.685-1.794 4.446-4.57 4.446-2.778 0-4.572-1.701-4.572-4.415 0-2.754 1.77-4.454 4.572-4.454 2.776 0 4.57 1.73 4.57 4.423zm0-6.157c-1.219-1.307-2.983-2.024-5.435-2.024-5.29 0-8.902 3.262-8.902 8.151 0 4.793 3.587 8.146 8.815 8.146 2.397 0 4.157-0.606 5.522-1.965v1.444h4.825v-20.861l-4.825 1.244v5.865z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.95-335.96c2.804 0 4.567 1.7 4.567 4.454 0 2.714-1.791 4.415-4.567 4.415-2.774 0-4.566-1.761-4.566-4.446 0-2.693 1.792-4.423 4.566-4.423zm-4.566-7.599-4.827-1.244v20.861h4.827v-1.444c1.358 1.359 3.121 1.965 5.52 1.965 5.231 0 8.813-3.353 8.813-8.146 0-4.889-3.613-8.151-8.9-8.151-2.457 0-4.22 0.717-5.433 2.024v-5.865z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.81-323.94v-14.405h4.825v0.89c1.445-1.74 2.974-2.606 4.713-2.606 0.345 0 0.779 0.056 1.356 0.113v4.107c-0.465-0.061-0.983-0.061-1.533-0.061-2.805 0-4.536 1.85-4.536 4.996v6.966h-4.825z",
    style: {
      fillRule: "nonzero",
      fill: "#265787"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27199 0 0 .27199 -78.096 -584.9)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "2213.4px",
    y: "784.854px",
    style: {
      fill: "rgb(35,97,146)",
      fontFamily: "'OpenSans-Semibold', 'Open Sans', sans-serif",
      fontSize: 50,
      fontWeight: 600
    }
  }, "\xAE"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlender);
export default __webpack_public_path__ + "static/media/Logo_Blender.e1f1eeb2c8d15e970e8c4cf1728577de.svg";
export { ForwardRef as ReactComponent };